<template>
  <div  :class="{'opacity-50 cursor-not-allowed': (!isLeader)}">
    <h1
      class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b uppercase"
    >{{ $t("checklist.checklist") }}</h1>
    <div v-if="payError" class="flex items-center px-4 py-2 my-4 rounded-md shadow-error" style="background: linear-gradient(329.36deg, #F43535 0%, #DD1111 100%)">
      <i class="sp-icon-file-code-warning-1 text-red-darker relative inline-block bg-white rounded-full text-center text-md font-300 leading-loose p-2 mr-4"></i>
      <p class="text-2sm text-bold text-white"> {{ $t("payment.notPayed")}} </p>
    </div>
    <div v-if="currentUser.role != 'sso' && session && session.startup_application && !['Air', 'Air2'].includes(session.startup_application.type) && !isStartupEcosystem">
      <div v-if="session.startup_application && !pay">
        <h2
          class="text-xbold text-blue text-2sm"
          v-if="session.session_name"
        >{{ session.session_name.label }}</h2>

        <div class="lg:max-w-md">
          <div class="flex justify-between items-center shadow-checklist rounded-md p-3 my-4">
            <div
              class="relative pl-10 font-medium text-sm sm:text-2sm"
              :class="{
                'text-green': checklist.form_criteria,
                'text-grey-darkest': !checklist.form_criteria
                }"
            >
              <i
                :class="{
                'sp-icon-check-circle-1-copy text-grren border-green': checklist.form_criteria,
                'sp-icon-file-code-warning-1 text-grey border-grey': !checklist.form_criteria
                }"
                class="absolute text-center text-2xl font-300 leading-loose mr-2"
                style="top:-3px; left:5px;"
              ></i>

              <span v-if="checklist.form_criteria">{{ $t("checklist.doneCriteria") }}</span>
              <span v-else>{{ $t("checklist.notDoneCriteria") }}</span>
            </div>
            <div v-if="!checkPayent()">
              <sp-link
                class="text-grey-darkest"
                theme="success"
                size="xsmall"
                v-if="checklist.form_criteria"
                :to="{
                  name: 'FormCriteria',
                  params: { app_id: $route.params.app_id }
                  }"
              >{{ $t("checklist.update") }}</sp-link>
              <sp-link
                class="text-grey-darkest"
                theme="grey"
                size="xsmall"
                v-else
                :to="{
                  name: 'FormCriteria',
                  params: { app_id: $route.params.app_id }
                  }"
              >{{ $t("checklist.resume")}}</sp-link>
            </div>
          </div>
          <div class="flex justify-between items-center shadow-checklist rounded-md p-3 my-4">
            <div
              class="relative pl-10 font-medium text-sm sm:text-2sm"
              :class="{
                'text-green': checklist.innovations,
                'text-grey-darkest': !checklist.innovations
                }"
            >
              <i
                :class="{
                'sp-icon-check-circle-1-copy text-grren border-green': checklist.innovations,
                'sp-icon-file-code-warning-1 text-grey border-grey': !checklist.innovations
                }"
                class="absolute text-center text-2xl font-300 leading-loose mr-2"
                style="top:-3px; left:5px;"
              ></i>

              <span v-if="checklist.innovations">{{ $t("checklist.doneInnovations") }}</span>
              <span v-else>{{ $t("checklist.notDoneTnnovations") }}</span>
            </div>
            <div v-if="!checkPayent()">
              <sp-link
                class="text-grey-darkest"
                theme="success"
                size="xsmall"
                v-if="checklist.innovations"
                :to="{
                  name: 'FormInnovations',
                  params: { app_id: $route.params.app_id }
                  }"
              >{{ $t("checklist.update") }}</sp-link>

              <sp-link
                class="text-grey-darkest"
                theme="grey"
                size="xsmall"
                v-else
                :to="{
                  name: 'FormInnovations',
                  params: { app_id: $route.params.app_id }
                  }"
              >{{ $t("checklist.resume")}}</sp-link>
            </div>
          </div>
          <div class="flex justify-between items-center shadow-checklist rounded-md p-3 my-4">
            <div
              class="relative pl-10 font-medium text-sm sm:text-2sm"
              :class="{
                'text-green': checklist.teams,
                'text-grey-darkest': !checklist.teams
                }"
            >
              <i
                :class="{
                'sp-icon-check-circle-1-copy text-grren border-green': checklist.teams,
                'sp-icon-file-code-warning-1 text-grey border-grey': !checklist.teams
                }"
                class="absolute text-center text-2xl font-300 leading-loose mr-2"
                style="top:-3px; left:5px;"
              ></i>

              <span v-if="checklist.teams">{{ $t("checklist.doneTeam") }}</span>
              <span v-else>{{ $t("checklist.notDoneTeam") }}</span>
            </div>
            <div v-if="!checkPayent()">
              <sp-link
                class="text-grey-darkest"
                theme="success"
                size="xsmall"
                v-if="checklist.teams"
                :to="{
                  name: 'team-edit',
                  params: { team_id: this.session.user_auth.id, app_id: $route.params.app_id }
                  }"
              >{{ $t("checklist.update") }}</sp-link>

              <sp-link
                class="text-grey-darkest"
                theme="grey"
                size="xsmall"
                v-else
                :to="{
                  name: 'team-edit',
                  params: { team_id: this.session.user_auth.id, app_id: $route.params.app_id }
                  }"
              >{{ $t("checklist.resume") }}</sp-link>
            </div>
          </div>

          <!-- <div class="flex justify-between items-center shadow-checklist rounded-md p-3 my-4">
            <div
              class="relative pl-10 font-medium text-sm sm:text-2sm"
              :class="{
                'text-green': checkPayent(),
                'text-grey-darkest': !checkPayent()
                }"
            >
              <i
                :class="{
                'sp-icon-check-circle-1-copy text-grren border-green': checkPayent(),
                'sp-icon-file-code-warning-1 text-grey border-grey': !checkPayent()
                }"
                class="absolute text-center text-2xl font-300 leading-loose mr-2"
                style="top:-3px; left:5px;"
              ></i>

              <span v-if="checkPayent()">{{ $t("checklist.donePayment") }}</span>

              <span v-else-if="blocked && !forms_valid">{{ $t("checklist.notDoneFom") }}</span>
              <span v-else-if="blocked && forms_valid">{{ $t("checklist.next_session") }}</span>
              <span
                v-else-if="!blocked && forms_valid && session.startup_application.status == 0"
              >{{ $t("checklist.youCantPay") }}</span>
              <span
                v-else-if="!blocked && forms_valid && session.startup_application.status == 11"
              >{{ $t("checklist.submit_application") }}</span>
            </div>

            <div v-if="session.startup_application.status == 0">
              <sp-button
                v-if="!checkPayent()"
                :disabled="(blocked && !forms_valid) || !isLeader"
                @click="submitApplication()"
                :class="{'opacity-50 cursor-not-allowed':blocked }"
                theme="grey"
                space="xxsmall"
                size="xsmall"
              >1111</sp-button>
            </div>

            <div v-if="session.startup_application.status == 11">
              <sp-button
                v-if="!checkPayent()"
                :disabled="(blocked && !forms_valid) || !isLeader"
                @click="submitApplication()"
                :class="{'opacity-50 cursor-not-allowed':blocked}"
                theme="grey"
                space="xxsmall"
                size="xsmall"
              >{{ $t("checklist.pay1") }}</sp-button>
            </div>
          </div> -->
        </div>

        <div
          v-if="session.startup_application.status == 0"
          class="flex items-center justify-end w-auto bg-white shadow-box mt-8 p-8 pb-2 -mx-3"
        >
          <sp-button
            :disabled="(blocked && !forms_valid)
            || session.application_session != null && session.application_session.max_apps == true || !isLeader && blocked || session.application_session.status == '2'
            || session.application_session != null && session.application_session.status != '1'
            || session.application_session != null && session.application_session.first_step_limit_date == true
            || session.application_session != null && session.application_session.status == '1' && session.application_session.first_step_status != '1'"
            @click="submitApplication()"
            :class="{'opacity-25 cursor-not-allowed': blocked }"
            theme="warning"
            space="normal"
            size="normal"
          >{{ $t("checklist.pay1") }}</sp-button>
        </div>

        <div
          v-if="!blocked  && session.startup_application.status == 11"
          class="flex items-center justify-end w-auto bg-white shadow-box mt-8 p-8 pb-2 -mx-3"
        >
          <sp-button
            v-if="!checkPayent()"
            @click="submitApplication()"
            type="submit"
            :class="{'opacity-25 cursor-not-allowed': blocked }"
            theme="warning"
            space="normal"
            size="normal"
            :disabled="session.application_session != null && session.application_session.max_apps == true
            || session.application_session != null && session.application_session.status != '1'
            || session.application_session != null && session.application_session.first_step_limit_date == true
            || session.application_session != null && session.application_session.status == '1' && session.application_session.first_step_status != '1'"
          >{{ $t("checklist.pay1") }}</sp-button>
        </div>
      </div>
    </div>
    <div v-else>
      <h2 class="text-xbold text-blue text-2sm">
        <div v-if="ecosystemApp && ecosystemApp.application && ecosystemApp.application.type =='Certif'">{{ $t("ecosystem.certif") }}</div>
        <div v-if="ecosystemApp && ecosystemApp.application && ecosystemApp.application.type =='Deal'">{{ $t("ecosystem.deal") }}</div>
        <div v-if="ecosystemApp && ecosystemApp.application && ecosystemApp.application.type =='Sail'">{{ $t("ecosystem.sail") }}</div>
        <div v-if="ecosystemApp && ecosystemApp.application && ecosystemApp.application.type =='Air'">{{ $t("ecosystem.air") }}</div>
        <div v-if="ecosystemApp && ecosystemApp.application && ecosystemApp.application.type =='Air2'">{{ $t("ecosystem.air2") }}</div>
      </h2>

      <div v-if="!error">
        <div class="lg:max-w-md">
          <div v-for="(element, index) in checklist" :key="index">
            <div class="flex justify-between items-center shadow-checklist rounded-md p-3 my-4">
              <div
                class="relative pl-10 font-medium text-sm sm:text-2sm"
                :class="{
                  'text-green': element,
                  'text-grey-darkest': !element
                  }"
              >
                <i
                  :class="{
                  'sp-icon-check-circle-1-copy text-grren border-green': element,
                  'sp-icon-file-code-warning-1 text-grey border-grey': !element
                  }"
                  class="absolute text-center text-2xl font-300 leading-loose mr-2"
                  style="top:-3px; left:5px;"
                ></i>

                <div v-if="element">
                  <span v-if="index == 'structure_and_organization'">{{ $t("ecosystem.done_structure_and_organization") }}</span>
                  <span v-if="index == 'anterior_programs'">{{ $t("ecosystem.done_anterior_programs") }}</span>
                  <span v-if="index == 'deal_form'">{{ $t("ecosystem.done_deal_form") }}</span>
                  <span v-if="index == 'sail_form'">{{ $t("ecosystem.done_sail_form") }}</span>
                  <span v-if="index == 'teams'">{{ $t("checklist.doneTeam") }}</span>
                  <span v-if="index == 'general_infos_air'">{{ $t("ecosystem.done_general_info_form") }}</span>
                  <span v-if="index == 'general_infos_air2'">{{ $t("ecosystem.done_general_info_form") }}</span>
                  <span v-if="index == 'air'">{{ $t("ecosystem.done_air_form") }}</span>
                  <span v-if="index == 'air2'">{{ $t("ecosystem.done_air2_form") }}</span>
                  <span v-if="index == 'general_infos_d4d'">{{ $t("ecosystem.done_general_info_d4d_form") }}</span>
                  <span v-if="index == 'funding_requirements'">{{ $t("ecosystem.done_funding_requirements_form") }}</span>
                </div>
                <div v-else>
                  <span v-if="index == 'structure_and_organization'">{{ $t("ecosystem.not_done_structure_and_organization") }}</span>
                  <span v-if="index == 'anterior_programs'">{{ $t("ecosystem.not_done_anterior_programs") }}</span>
                  <span v-if="index == 'deal_form'">{{ $t("ecosystem.not_done_deal_form") }}</span>
                  <span v-if="index == 'sail_form'">{{ $t("ecosystem.not_done_sail_form") }}</span>
                  <span v-if="index == 'teams'">{{ $t("checklist.notDoneTeam") }}</span>
                  <span v-if="index == 'general_infos_air'">{{ $t("ecosystem.not_general_info_form") }}</span>
                  <span v-if="index == 'general_infos_air2'">{{ $t("ecosystem.not_general_info_form") }}</span>
                  <span v-if="index == 'air'">{{ $t("ecosystem.not_done_air_form") }}</span>
                  <span v-if="index == 'air2'">{{ $t("ecosystem.not_done_air2_form") }}</span>
                  <span v-if="index == 'general_infos_d4d'">{{ $t("ecosystem.not_done_general_info_d4d_form") }}</span>
                  <span v-if="index == 'funding_requirements'">{{ $t("ecosystem.not_done_funding_requirements_form") }}</span>
                </div>
              </div>
              <div>
                <sp-link
                  class="text-grey-darkest"
                  theme="success"
                  size="xsmall"
                  v-if="element && ecosystemApp.application.status != '1'"
                  :to="{
                    name: formatRouteName(index),
                    params: {
                      formName: index.replace(new RegExp('_', 'g'), '-'),
                      ecoAppId: ecosystemApp.application.hash_id || ecosystemApp.application.id,
                      appType: ecosystemApp.application.type.toLowerCase()
                    }
                  }"
                >{{ $t("checklist.update") }}</sp-link>

                <sp-link
                  class="text-grey-darkest"
                  theme="grey"
                  size="xsmall"
                  :id="index"
                  v-else-if="!element && ecosystemApp.application.status != '1'"
                  :to="{
                    name: formatRouteName(index),
                    params: {
                      formName: index.replace(new RegExp('_', 'g'), '-'),
                      ecoAppId: ecosystemApp.application.hash_id || ecosystemApp.application.id,
                      appType: ecosystemApp.application.type.toLowerCase()
                    }
                  }"
                >{{ $t("checklist.resume") }}</sp-link>
              </div>
            </div>
          </div>
          <div class="flex justify-between items-center shadow-checklist rounded-md p-3 my-4">
            <div
              class="relative pl-10 font-medium text-sm sm:text-2sm"
              :class="{
                'text-green': checkPayentEcoSystem() && (canSubmit || ecosystemSession && ecosystemSession.first_step_status == '1'),
                'text-grey-darkest': !canSubmit && !checkPayentEcoSystem()
                }"
            >
              <i
                :class="{
                'sp-icon-check-circle-1-copy text-green border-green': checkPayentEcoSystem() && (canSubmit || ecosystemSession && ecosystemSession.first_step_status == '1'),
                'sp-icon-file-code-warning-1 text-grey border-grey': !canSubmit || !checkPayentEcoSystem()
                }"
                class="absolute text-center text-2xl font-300 leading-loose mr-2"
                style="top:-3px; left:5px;"
              ></i>
              <span v-if="ecosystemSession && ecosystemSession.first_step_status == '0'">{{ $t("checklist.next_session") }}</span>
              <span v-else-if="!canSubmit && !checkPayentEcoSystem()">{{ $t("checklist.notDoneFom") }}</span>
              <span
                v-else-if="canSubmit"
              >{{ $t("checklist.submit_application") }}</span>
               <span v-else>{{ $t("checklist.donePayment") }}</span>
            </div>
            <div>
              <sp-button
                v-if="!checkPayentEcoSystem()"
                :disabled="!canSubmit || !isLeader || session.application_session != null && session.application_session.max_apps == true"
                @click="submitApplication()"
                :class="{'opacity-50 cursor-not-allowed':!canSubmit }"
                theme="grey"
                space="xxsmall"
                size="xsmall"
              >{{ $t("checklist.submit") }}</sp-button>
            </div>
          </div>
        </div>

        <div
          class="flex items-center justify-end w-auto bg-white shadow-box mt-8 p-8 pb-2 -mx-3"
        >
          <sp-button
            v-if="!checkPayentEcoSystem()"
            @click="submitApplication()"
            type="submit"
            theme="warning"
            space="normal"
            size="normal"
            :disabled="!canSubmit || !isLeader || session.application_session != null && session.application_session.max_apps == true
            || session.application_session != null && session.application_session.status != '1'
            || session.application_session != null && session.application_session.first_step_limit_date == true
            || session.application_session != null && session.application_session.status == '1' && session.application_session.first_step_status != '1'"
            :class="{'opacity-50 cursor-not-allowed disabled':!canSubmit }"
          >{{ $t("checklist.pay1") }}</sp-button>
        </div>
      </div>
      <div v-else>
        <h1 class="text-center text-black">{{ $t("checklist.submit_application_limit") }}</h1>
        <p class="text-center text-black mt-5">{{ $t("checklist.limit_reached") }}</p>
      </div>

    </div>
    <div v-if="!blocked && pay">
      <iframe
        name="iframe_name"
        id="iframe_id"
        :src="payment_url"
        style="width:100%;height:700px;border:0 none;"
        scrolling="no"
        frameborder="0"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
      ></iframe>
    </div>

    <!-- <modal
      name="check_app_with_date"
      :adaptive="true"
      :resizable="true"
      :maxHeight="200"
      transition="nice-modal-fade"
    >
      <div class="mb-4 p-4 text-white bg-blue">
        <h3 class="font-bold text-xl text-white">{{ $t('candidat.warning') }}</h3>
      </div>
      <div class="mb-4 p-4 text-center">
        <p>
          <span>{{this.msg_apply_application}}</span>
        </p>
      </div>
    </modal> -->
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import ApiService from "@/common/api.service";
import { checklist_GET, UPDATE_STATUS_APPLICATION, GET_ECOSYSTEM_APP_CHECKLIST, UPDATE_ECOSYSTEM_STATUS_APPLICATION, FETCH_ECOSYSTEM_APPLICATION, CHECK_AUTH } from "@/store/actions.type";
import ButtonVue from "../../components/spKit/Button.vue";
import { Fragment } from "vue-fragment";
import Link from "@/components/spKit/Link.vue";
import { PAYMENT_URL } from "@/common/config";
import Vue from "vue";
import VModal from "vue-js-modal";
import { SET_ECOSYSTEM_MENU_ACTIVE } from "@/store/mutations.type";
Vue.use(VModal, {
  dialog: true
});
export default {
  name: "checklist",
  data() {
    return {
      inProgress: false,
      error: null,
      blocked: true,
      forms_valid: false,
      pay: false,
      checklist: 0,
      payment_url: PAYMENT_URL + "?id=" + this.$route.params.app_id,
      // msg_apply_application: null,
      isLeader: true,
      payError: false,
      application: []
    };
  },
  modal: {
    visible: true
  },
  components: {
    "sp-button": ButtonVue,
    "sp-link": Link,
    "fragment": Fragment
  },
  methods: {
    formatRouteName(route) {
      if (route == 'teams') {
        return 'EcoTeam';
      }
      let blocks = route.split('_');
      blocks.forEach(function callback(element, index) {
        blocks[index] = element.charAt(0).toUpperCase()+element.slice(1);
      });

      return blocks.join('');
    },
    // goPay() {
    //   if (
    //     this.checklist.form_criteria &&
    //     this.checklist.innovations &&
    //     this.checklist.teams &&
    //     this.session.application_session != null &&
    //     this.session.application_session.first_step_status == "1"
    //   ) {
    //       let application_id = this.session.startup_application.id
    //       ApiService.get(`/application/${application_id}/check_submit`)
    //       .then((data) => {
    //         if(data.data.data.submit_application == true){
    //             this.blocked = false;
    //             this.pay = true;
    //         }else{
    //             this.msg_apply_application = data.data.data.msg_apply_application;
    //             this.$modal.show("check_app_with_date");
    //         }
    //       })
    //       .catch(() => {});
    //   }
    // },
    checkPayent() {
      return (
        this.session &&
        this.session.startup_application &&
        this.session.application_session != null &&
        this.session.startup_application.status != "0" &&
        this.session.application_session != null &&
        this.session.startup_application.status != "11"
      );
    },
    checkPayentEcoSystem() {
      return (
        this.ecosystemApp &&
        this.ecosystemApp.application &&
        this.ecosystemApp.application != null &&
        this.ecosystemApp.application.status != "0" &&
        this.ecosystemApp.application != null &&
        this.ecosystemApp.application.status != "11"
      );
    },
    submitApplication(applicationId) {
      applicationId = this.$route.params.app_id;
     
      if(this.ecosystemApp.application){
        this.$store
        .dispatch(UPDATE_ECOSYSTEM_STATUS_APPLICATION, applicationId)
        .then((data) => {
          this.$router.push({ name: "Status" });
        })
        .catch(() => {
          this.error = true;
        })
      }else{
        this.application.sessionId = this.session.application_session.id
        this.application.applicationId = applicationId
        this.$store
        .dispatch(UPDATE_STATUS_APPLICATION, this.application.applicationId)
        .then(({ data }) => {
          console.log(data);
          this.$router.push({ name: "Status" });
        })
      }
      
    },
    fetchCheckListData(){
      this.$Progress.start();
    if (this.currentUser.role == 'sso' || this.isStartupEcosystem) {
      this.$store.dispatch(GET_ECOSYSTEM_APP_CHECKLIST, this.ecosystemApp.application.hash_id || this.ecosystemApp.application.id)
        .then((data) => {
          data = data.data.data;
          this.isLeader = data.isLeader;
          delete data.isLeader;
          delete data.progress;
          this.checklist = data;
          this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, true);
        })
        .catch(() => {
          this.$router.push({ name: "home" });
        });
      this.$Progress.finish();
    } else {
      this.$store
        .dispatch(checklist_GET, this.$route.params.app_id)
        .then(({ data }) => {
          if (this.session &&
            this.session.startup_application &&
            this.session.user_auth &&
            this.session.startup_application.user_id != this.session.user_auth.id
          ) {
            this.isLeader = false;
          }
          this.$Progress.finish();
          this.checklist = data;
          if (
            this.checklist.form_criteria &&
            this.checklist.innovations &&
            this.checklist.teams
          ) {
            this.forms_valid = true;
            if(this.session.startup_application.status == "11"){
                this.blocked = false;
            }
          }
          if (
            this.checklist.form_criteria &&
            this.checklist.innovations &&
            this.checklist.teams &&
            this.session.application_session != null &&
            this.session.application_session.first_step_status == "1"
          ) {
            this.blocked = false;
          }
        })
        .catch(() => {
          this.$router.push({ name: "home" });
        });
    }
    },
    fetchAppData(role){
      if(!this.ecosystemApp.application && (role == 'sso' || localStorage.getItem('ecosystem') === 'true')){
      this.$store.dispatch(FETCH_ECOSYSTEM_APPLICATION, this.$route.params.app_id)
        .then(() => this.fetchCheckListData())
        .catch(() => {
          this.$router.push({ name: "home" });
        });
    }else{
      this.fetchCheckListData()
      }
    }
  },
  mounted() {
    if(!this.currentUser.role){
      this.$store.dispatch(CHECK_AUTH)
        .then(role => this.fetchAppData(role))
    }else{
      this.fetchAppData(this.currentUser.role)
    }
    if (this.$route.query.payed === "0") {
      this.payError = true;
    }
  },
  watch: {
    errors() {
      this.$Progress.fail();
    }
  },
  computed: {
    ...mapGetters(["session", "currentUser", "ecosystemApp", "ecosystemSession", "ecosystemProgress"]),
    ...mapState({
      errors: state => state.session.errors
    }),
    isStartupEcosystem() {
      let startupEco = false;
      let hashId = this.$route.params.app_id;
      if (
        this.ecosystemApp &&
        this.ecosystemApp.application &&
        ["Air", "Air2", "D4D"].includes(this.ecosystemApp.application.type) &&
        this.ecosystemApp.application.id == hashId
      ) {
        startupEco = true;
      }

      return startupEco;
    },
    canSubmit() {
      // Initialize by false to avoid showing submit
      // button when mounting component at first
      let can = false;
      if (
        this.ecosystemApp &&
        this.ecosystemApp.application &&
        ["11"].includes(this.ecosystemApp.application.status) &&
        this.ecosystemProgress == 100
      ) {
        return true;
      }
      if (
        this.ecosystemApp &&
        this.ecosystemApp.application &&
        !["0", "11"].includes(this.ecosystemApp.application.status)
      ) {
        return can;
      }
      if (
        !this.ecosystemSession ||
        (this.ecosystemSession && this.ecosystemSession.first_step_status &&
          this.ecosystemSession.first_step_status == "0")
      ) {
        return can;
      }
      for (const key in this.checklist) {
        if (this.checklist[key]) {
          can = true;
        } else {
          can = false;
          break;
        }
      }
      return can;
    }
  },
  beforeDestroy() {
    this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, false);
  }
};
</script>
